import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { MenuItem } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Translator from 'translator';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import {
    refreshBox,
    restartBox,
    startVpn,
    stopVpn,
    updateBox,
    homeDelete,
    configureTendaRouter,
    logClientInterfaceConnection,
    getClientToken,
} from '../../../data/Boxes/actions';
import getSelectors from '../selectors';

class ActionsMenu extends Component {
    static propTypes = {
        homeDelete: PropTypes.func.isRequired,
        startVpn: PropTypes.func.isRequired,
        stopVpn: PropTypes.func.isRequired,
        refreshBox: PropTypes.func.isRequired,
        handleLoading: PropTypes.func,
        boxSwapAction: PropTypes.func,
        restartBox: PropTypes.func.isRequired,
        // clientInterface: PropTypes.string.isRequired,
        getClientToken: PropTypes.func.isRequired,
        updateBox: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homeId: PropTypes.number,
        boxId: PropTypes.number,
        boxMac: PropTypes.string,
    };

    static defaultProps = {
        handleLoading: null,
        boxSwapAction: null,
        homeId: 0,
        boxId: 0,
        boxMac: '',
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    updateBox = () => {
        const { updateBox, boxMac, history } = this.props;

        Toastr.confirm(
            Translator.translate(`generic.home.updateBox.confirmBoxUpdate`, Translator.translate(`${history.environment}.centerName`)),
            Translator.translate(`generic.home.updateBox.confirmBoxUpdateTitle`, Translator.translate(`${history.environment}.centerName`)),
            {
                onYes: () => {
                    this.handleLoading(true);
                    return updateBox(boxMac)
                        .then(() => {
                            Toastr.success(
                                Translator.translate(`generic.home.updateBox.success`, Translator.translate(`${history.environment}.centerName`)),
                            );
                        })
                        .catch(err => {
                            Toastr.error(
                                Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                                Translator.translate(`generic.home.updateBox.error`, Translator.translate(`${history.environment}.centerName`)),
                            );
                        })
                        .finally(() => {
                            this.handleLoading(false);
                        });
                },
            },
        );
    };
    restartBox = () => {
        const { restartBox, boxMac, history } = this.props;

        Toastr.confirm(
            Translator.translate(`generic.home.restartBox.confirmBoxRestart`, Translator.translate(`${history.environment}.centerName`)),
            Translator.translate(`generic.home.restartBox.confirmBoxRestartTitle`, Translator.translate(`${history.environment}.centerName`)),
            {
                onYes: () => {
                    this.handleLoading(true);
                    return restartBox(boxMac)
                        .then(() => {
                            Toastr.success(
                                Translator.translate(`generic.home.restartBox.success`, Translator.translate(`${history.environment}.centerName`)),
                            );
                        })
                        .catch(err => {
                            Toastr.error(
                                Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                                Translator.translate(`generic.home.restartBox.error`, Translator.translate(`${history.environment}.centerName`)),
                            );
                        })
                        .finally(() => {
                            this.handleLoading(false);
                        });
                },
            },
        );
    };
    startVpn = () => {
        const { startVpn, boxMac } = this.props;
        this.handleLoading(true);
        return startVpn(boxMac)
            .then(() => {
                Toastr.success(Translator.translate(`generic.home.startVpn.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.home.startVpn.error`),
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };
    stopVpn = () => {
        const { stopVpn, boxMac } = this.props;

        this.handleLoading(true);
        return stopVpn(boxMac)
            .then(() => {
                Toastr.success(Translator.translate(`generic.home.stopVpn.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.home.stopVpn.error`),
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };

    clientInterface = () => {
        const { getClientToken, clientInterface, homeId } = this.props;

        if (!clientInterface) {
            return Toastr.error(Translator.translate('generic.home.clientInterface.errorConfig'));
        }

        getClientToken(homeId).then(res => {
            if (res.data.token) {
                window.open(`${clientInterface}?support=${res.data.token.token}`);
            }
        });
    };

    refreshBox = () => {
        const { refreshBox, boxMac, history } = this.props;

        this.handleLoading(true);
        return refreshBox(boxMac)
            .then(() => {
                Toastr.success(Translator.translate(`generic.home.refreshBox.success`, Translator.translate(`${history.environment}.centerName`)));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.home.refreshBox.error`, Translator.translate(`${history.environment}.centerName`)),
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };

    boxSwap = () => {
        const { boxSwapAction } = this.props;
        boxSwapAction();
    };

    configureTendaRouter = () => {
        const { configureTendaRouter, boxMac, boxId } = this.props;

        this.handleLoading(true);
        return configureTendaRouter(boxMac, boxId)
            .then(SSID => {
                Toastr.success(Translator.translate('generic.home.configureTendaRouter.success'), SSID);
            })
            .catch(err => {
                Toastr.error(Translator.translate('generic.home.configureTendaRouter.error'), err);
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };

    handleLoading = bool => {
        const { handleLoading } = this.props;
        if (handleLoading) handleLoading(bool);
    };

    homeDelete = () => {
        const { homeDelete, history, homeId, boxId, boxMac } = this.props;

        Toastr.confirm(Translator.translate('generic.home.delete.confirm'), `⚠️ ${Translator.translate('generic.home.delete.confirmTitle')}`, {
            onYes: () => {
                this.handleLoading(true);
                return homeDelete(homeId, boxId, boxMac)
                    .then(() => {
                        Toastr.success(Translator.translate('generic.home.delete.success'));
                    })
                    .catch(err => {
                        Toastr.error(
                            Translator.translateWithFallback(`generic.home.delete.error.${err.message}`, err.message),
                            Translator.translate(`generic.home.delete.error.title`),
                        );
                    })
                    .finally(() => {
                        this.handleLoading(false);
                    });
            },
        });
    };

    render() {
        const { profile, history, boxSwapAction, boxMac } = this.props;
        let menuItems = [];
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`refreshBox_${history.environment}`)) {
            menuItems.push(
                <MenuItem key="refreshBox" onClick={this.refreshBox} disabled={!boxMac}>
                    {Translator.translate(`generic.home.refreshBox.action`, Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>,
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`updateBox_${history.environment}`)) {
            menuItems.push(
                <MenuItem key="updateBox" onClick={this.updateBox} disabled={!boxMac}>
                    {Translator.translate(`generic.home.updateBox.action`, Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>,
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`restartBox_${history.environment}`)) {
            menuItems.push(
                <MenuItem key="restartBox" onClick={this.restartBox} disabled={!boxMac}>
                    {Translator.translate(`generic.home.restartBox.action`, Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>,
            );
        }
        if (
            (boxSwapAction && profile.get('admin')) ||
            profile.getIn(['user_rights', history.environment], []).includes(`boxSwap_${history.environment}`)
        ) {
            menuItems.push(
                <MenuItem key="boxSwap" onClick={this.boxSwap} disabled={!boxMac}>
                    {Translator.translate(`generic.home.boxSwap.action`, Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>,
            );
        }
        menuItems.push(
            <MenuItem key="configureTendaRouter" onClick={this.configureTendaRouter}>
                {Translator.translate(`generic.home.configureTendaRouter.action`, Translator.translate(`${history.environment}.centerName`))}
            </MenuItem>,
        );
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('startVpn')) {
            menuItems.push(
                <MenuItem key="startVpn" onClick={this.startVpn} disabled={!boxMac}>
                    {Translator.translate(`generic.home.startVpn.action`)}
                </MenuItem>,
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('stopVpn')) {
            menuItems.push(
                <MenuItem key="stopVpn" onClick={this.stopVpn} disabled={!boxMac}>
                    {Translator.translate(`generic.home.stopVpn.action`)}
                </MenuItem>,
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('clientInterface')) {
            menuItems.push(
                <MenuItem key="clientInterface" onClick={this.clientInterface} disabled={!boxMac}>
                    {Translator.translate(`generic.home.clientInterface.action`)}
                </MenuItem>,
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`homeDelete_${history.environment}`)) {
            menuItems.push(
                <MenuItem key="homeDelete" onClick={this.homeDelete}>
                    <span style={{ color: 'red' }}>{Translator.translate(`generic.home.delete.action`)}</span>
                </MenuItem>,
            );
        }

        return menuItems;
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state),
        clientInterface: selectors.getClientInterface(state),
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/components/ActionsMenu',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        refreshBox,
                        updateBox,
                        restartBox,
                        startVpn,
                        stopVpn,
                        logClientInterfaceConnection,
                        getClientToken,
                        homeDelete,
                        configureTendaRouter,
                    }),
                    dispatch,
                ),
        )(ActionsMenu),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/ActionsMenu.js